<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
         <div class="card">
           <div class="card-header">
            <b-row>
            <b-col cols="12" lg="6" md="12">
              <b-col>
                <b-col>
                  <b-form-group label-cols-sm="3" label="ค้นหาแบบพิเศษ" class="mb-0">
                    <a-input-search v-model="formkey.keyWord" placeholder="" enter-button="Search" @search="setKeyword"
                      allow-clear />
                    <span class="form-text"><span class="text-danger">*</span>ค้นหาด้วย <span
                        class="text-danger">นามสกุล</span></span>
                  </b-form-group>
                </b-col>
              </b-col>
            </b-col>
            <b-col cols="6" lg="6" md="6">
              <b-col>
                <b-col>
                  <div class="d-flex justify-content-end" style="margin: 3px;">
                <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มบัญชีธนาคาร</a>
                  </div>
                </b-col>
              </b-col>
            </b-col>
          </b-row>
             <!-- <div class="d-flex flex-column justify-content-center mr-auto">
               <h5 class="mb-0"></h5>
             </div>
             <div class="d-flex flex-column justify-content-center">
               <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มบัญชีดำ</a>
             </div> -->
           </div>
           <div class="card-body">
             <a-table :columns="columns" :dataSource="data" rowKey='blackListId' :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
               <span slot="status" slot-scope="text">
                 <a-tag :color="(text)?'green':'red'">
                   {{(text)?'บล็อคการใช้งาน':(!text)?'ปิดการบล็อค':"ไม่พบข้อมํูล"}}
                 </a-tag>
               </span>
               <span slot="activeStatus" slot-scope="text,record">
                 <a-switch :checked="!!parseInt(record.status)" @change="updateStatus(text,!record.status)" />
               </span>
               <span slot="Action" slot-scope="text,record">
                 <a-dropdown>
                   <a-menu slot="overlay">
                     <a-menu-item @click="showModal('update',record.blackListId)">แก้ไขข้อมูล </a-menu-item>
                   </a-menu>
                   <a-button style="margin-left: 8px"> จัดการ
                     <a-icon type="down" />
                   </a-button>
                 </a-dropdown>
               </span>
             </a-table>
           </div>
         </div>
        <a-modal :title="this.form.title" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk" @cancel="handleCancel">
            <a-form-model :model="form" layout="vertical">
                <a-form-model-item label="คู่ค้า">
                    <a-select v-model="form.operatorCode" placeholder="กรุณาเลือกข้อมูล" :disabled="(form.operatorMainId !== '' && form.type === 'update'|| form.operatorMainId > 0)">
                    <a-select-option v-for="(item , index) in operator" :key="index" :value="item.operatorCode">
                        {{ item.name }}
                    </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="นามสกุล">
                    <a-input v-model="form.lastName" />
                </a-form-model-item>
                <a-form-model-item label="หมายเหตุ">
                    <a-input v-model="form.remark" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  data() {
    return {
      visible: false,
      data: [],
      operator: [],
      formkey: {
        keyWord: '',
      },
      columns: [
        {
          title: 'ลำดับ',
          key: 'blackListId',
          dataIndex: 'blackListId',
        },
        {
          title: 'คู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          filters: [
            { text: 'MUGHUAY', value: 'MUGHUAY' },
            { text: 'DUCKBET', value: 'DUCKBET' },
          ],
          onFilter: (value, record) => record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'นามสกุล',
          key: 'lastName',
          dataIndex: 'lastName',
        },
        {
          title: 'สถานะ',
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'หมายเหตุ',
          key: 'remark',
          dataIndex: 'remark',
        },
        {
          title: 'เปิด/ปิด สถานะ',
          key: 'activeStatus',
          dataIndex: 'blackListId',
          scopedSlots: { customRender: 'activeStatus' },
        },
        {
          title: 'ตัวเลือก',
          key: 'Action',
          dataIndex: 'bankServiceId',
          scopedSlots: { customRender: 'Action' },
        },
      ],
      form: {
        type: null,
        title: null,
        blackListId: null,
        lastName: null,
        remark: null,
        operatorCode: null,
        status: null,
      },
    }
  },
  methods: {
    setKeyword(value, event) {
      this.getBlackList()
    },
    async getBlackList() {
      await apiClient.post('/blackList/getData', this.formkey).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.data = res.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    showModal(type, id = null) {
      this.clearForm()
      this.form.type = type
      this.form.title = (type === 'insert') ? 'เพิ่มบัญชีดำ' : 'แก้ไขบัญชีดำ'
      apiClient.get('/system/getOperator').then(res => {
        if (res.data.code === '000') {
          this.operator = []
          this.operator = res.data.responseData.data
          if (type === 'update') {
            this.getDataBlackList(id)
          } else {
            this.visible = !this.visible
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    getDataBlackList(id) {
      apiClient.get(`/blackList/getDataBlackList/${id}`).then(res => {
        if (res.data.code === '000') {
          const dataBlackLis = res.data.responseData.data[0]
          this.form.blackListId = dataBlackLis.id
          this.form.lastName = dataBlackLis.lastName
          this.form.operatorCode = dataBlackLis.operatorCode
          this.form.remark = dataBlackLis.remark

          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    clearForm() {
      this.form = {
        blackListId: null,
        lastName: null,
        operatorCode: null,
        remark: null,
        status: null,
      }
    },
    onSubmit() {
      const title = (this.form.type === 'update') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
      Swal.fire({
        icon: 'info',
        title: title,
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            // ส่งข้อมูลอัปเดทสถานะ
            if (this.form.blackListId) {
              return apiClient.put(`blackList/update/${this.form.blackListId}`, this.form).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error}`,
                )
              })
            } else {
              return apiClient.post('blackList/create', this.form).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error}`,
                )
              })
            }
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.visible = false
          this.confirmLoading = false
          this.getBlackList()
        }
      })
    },
    updateStatus(id, status) {
      apiClient.put(`/blackList/updateStatus/${id}`, { status: status }).then(res => {
        if (res.data.code === '000') {
          const iconError = (res.data.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: res.data.message })
          this.getBlackList()
        }
      }).catch(error => {
        Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    handleOk(e) {
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },
  },
  async created() {
    await this.getBlackList()
  },
}
</script>

<style>

</style>
